<div class="backdrop">
  <div class="alert-box">
    <div class="lds-circle"><div></div></div>
  </div>
</div>
